export const APP = {
    NAME: process.env.VUE_APP_NAME || 'goCharge',
    CURRENCY_SYMBOL: '€',
    HOURLY_PRICE: 0.50,
    MAX_PRICE_IN_HOURS: 6,
};
